import { render, staticRenderFns } from "./AppSetupHeader.vue?vue&type=template&id=36e21fab&"
import script from "./AppSetupHeader.vue?vue&type=script&lang=ts&"
export * from "./AppSetupHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports